define([
    'jquery',
    'globalVars',
    'mainGtm',
    'gtm',
    'matchSize'
], ($, { $body }, mainGtm, gtm, matchSize) => {
    return {
        init() {
            this.initEvents();
        },

        initEvents() {
            $body.on('click', '.js-product-tab-title', this.toggleTabs.bind(this));
        },

        toggleTabs(e) {
            e.preventDefault();

            const $target = $(e.currentTarget);
            const id = $target.data('id');
            const $links = $('.js-product-tab-title');
            const $content = $('.js-product-tab-content');
            const isActiveTab = $target.parent().hasClass('active');

            const $activeContent = $content.filter((i, el) => {
                return $(el).attr('id') === id;
            });

            if (matchSize().mobile) {
                $target.parent().toggleClass('active');
                $activeContent.slideToggle();

                if (!isActiveTab) {
                    this.pushGtmToggleTabs(id);
                }

                return;
            }

            $links.parent().removeClass('active');
            $target.parent().addClass('active');
            $content.removeClass('active').hide();
            $activeContent.addClass('active').fadeIn();

            if (!isActiveTab) {
                this.pushGtmToggleTabs(id);
            }
        },

        pushGtmToggleTabs(id) {
            mainGtm.toggleProductContent(gtm.getProduct(), id);
        },
    };
});
